/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Create_Project_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to create project. Please try again." |
*
* @param {Projects_Create_Project_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_create_project_error = /** @type {((inputs?: Projects_Create_Project_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Create_Project_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Erstellen des Projekts. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to create project. Please try again.")
});